<template>
    <p class="text-gray-400 text-sm md:text-xs flex-shrink-0">
        <slot name="title">
            {{ title }}
        </slot>
    </p>
    <p class="text-gray-700 text-base xs:text-lg space-size">
        <slot name="content">
            {{ content }}
        </slot>
    </p>
</template>

<script>
export default {
    props: {
        title: { type: String, default: '' },
        content: { type: String, default: '' },
    }
};
</script>
